var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRightsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.625,
    cy: 21,
    r: 21,
    fill: "#5AC8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8244 25.0165L25.7389 23.5324L27.3894 22.9695L27.5722 21.2361L28.814 20.0136L28.2236 18.3727L28.814 16.7318L27.5723 15.5094L27.3894 13.7759L25.739 13.213L24.8244 11.7289L23.0945 11.9378L21.625 11L20.1555 11.9379L18.4257 11.729L17.5111 13.2131L15.8606 13.776L15.6778 15.5094L14.436 16.7319L15.0264 18.3728L14.436 20.0137L15.6778 21.2361L15.8606 22.9696L17.5111 23.5325L18.4256 25.0165L20.1555 24.8077L21.625 25.7455L23.0945 24.8077L24.8244 25.0165ZM16.5692 18.3728C16.5692 15.585 18.8372 13.317 21.625 13.317C24.4128 13.317 26.6808 15.585 26.6808 18.3728C26.6808 21.1605 24.4128 23.4286 21.625 23.4286C18.8372 23.4286 16.5692 21.1605 16.5692 18.3728Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.625 14.4895C19.4838 14.4895 17.7418 16.2315 17.7418 18.3727C17.7418 20.5139 19.4838 22.2559 21.625 22.2559C23.7662 22.2559 25.5082 20.5139 25.5082 18.3727C25.5082 16.2315 23.7662 14.4895 21.625 14.4895Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 26.022L17.8211 26.2705L16.7338 24.5061L16.3642 24.3801L14.77 29.3632L17.6401 29.2053L19.8856 30.9999L21.207 26.8697L19.8789 26.022Z",
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5162 24.5062L25.4289 26.2705L23.3712 26.022L22.043 26.8697L23.3644 30.9999L25.6099 29.2053L28.4801 29.3632L26.8858 24.3801L26.5162 24.5062Z",
    fill: "#5AC8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.625 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightsInfo);
export default __webpack_public_path__ + "static/media/ic_rights_info.c92517e6f2a1ae92382816f24d7adc1e.svg";
export { ForwardRef as ReactComponent };